import AppImage from "@/components/react/AppImage";
import AppVideo from "@/components/react/AppVideo";
import Collapse from "@/components/react/Collapse";
import { css } from "@styled-system/css";
import { Flex } from "@styled-system/jsx";
import useI18n from "@/hooks/useI18n";

type FeatureType = {
  string: string;
  includedInFreeVersion: boolean;
  includedInPremiumVersion: boolean;
  description?: string;
  imgSrc?: string;
  videoSrc?: string;
};

export default function DescriptionCollapse({ isExpanded, feature }: { isExpanded: boolean; feature: FeatureType }) {
  const { t } = useI18n();
  if (!feature.description) return null;
  return (
    <Collapse isOpened={isExpanded}>
      <Flex className={css({ flexDirection: "column", w: "100%", zIndex: 1, bg: "surface" })}>
        <p className={css({ py: "0.75rem" })}>{t(feature.description)}</p>
        {feature.imgSrc && (
          <AppImage
            alt="screenshot"
            src={feature.imgSrc!}
            ignoreTheme
            className={css({
              w: "100%",
              h: "auto",
              borderRadius: "1rem",
              border: "1px solid",
              borderColor: "lowBorder"
            })}
          />
        )}

        {feature.videoSrc && (
          //  eslint-disable-next-line jsx-a11y/media-has-caption
          <AppVideo
            videoProps={{
              muted: true,
              autoPlay: true,
              loop: true,
              playsInline: true
            }}
            src={feature.videoSrc}
            className={css({
              w: "100%",
              h: "auto",
              maxWidth: "100%",
              borderRadius: "1rem",
              border: "1px solid",
              borderColor: "lowBorder"
            })}
          />
        )}
      </Flex>
    </Collapse>
  );
}
